import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { FormInput } from '../../../components/FormInput/FormInput';
import { PasswordInput } from '../../../components/FormInput/PasswordInput';

import classes from './EmailAndPasswordInputs.module.scss';

const EmailAndPasswordInputs = ({
  disabled,
  emailErrorMessageMap,
  passwordErrorMessageMap,
  onChangeEmail,
  onChangePassword,
  password,
  size,
  className,
}: {
  disabled: boolean;
  emailErrorMessageMap: Record<string, string>;
  passwordErrorMessageMap: Record<string, string>;
  onChangeEmail?: (email: string) => void;
  onChangePassword?: (password: string) => void;
  password?: string;
  size?: 'sm' | 'md';
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={classes.formRow}>
        <label
          className={classNames('form-field__label', classes.label, { [classes.sm]: size === 'sm' })}
          htmlFor="email"
        >
          {t('common.email')}*
        </label>
        <FormInput
          required
          autoComplete="email"
          dataTestId="signup-email-input-field"
          disabled={disabled}
          errorMessageMap={emailErrorMessageMap}
          id="email"
          name="email"
          placeholder={t('forms.emailAddress')}
          size={size}
          type="email"
          onChange={(event) => onChangeEmail && onChangeEmail(event.target.value)}
        />
      </div>

      <div className={classes.formRow}>
        <label
          className={classNames('form-field__label', classes.label, { [classes.sm]: size === 'sm' })}
          htmlFor="password"
        >
          {t('forms.password')}*
        </label>
        <PasswordInput
          required
          disabled={disabled}
          errorMessageMap={passwordErrorMessageMap}
          id="password"
          minLength={6}
          name="password"
          placeholder={t('auth.enterPassword')}
          size={size}
          value={password}
          onChange={(event) => onChangePassword && onChangePassword(event.target.value)}
        />
      </div>
    </div>
  );
};

export default EmailAndPasswordInputs;
